module.exports = __webpack_public_path__ + "static/media/headshot.d0fa18d1.png";